import { useCallback } from "react";
import useWorkspaceAccess from "./useWorkspaceAccess";
import { clearAuthCaches } from "../utils/authCache";

export function clearRBACCache() {
  clearAuthCaches();
}

export default function useRBAC() {
  const { permissions, isAdmin, loading, workspaceReady } = useWorkspaceAccess();

  const hasAccess = useCallback(
    (resource, access) => {
      if (isAdmin) return true;
      if (!permissions?.length) return false;

      return permissions.some(
        (permission) =>
          permission.resource_code === resource &&
          (permission.access_level_code === access ||
            permission.access_level_code === "WRITE"),
      );
    },
    [permissions, isAdmin],
  );

  return {
    permissions,
    hasAccess,
    isAdmin,
    loading: loading || !workspaceReady,
  };
}
